import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export default function Reveal({ children, delay = 0, y = 36, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ index, eyebrow, title, className = "" }) {
  return (
    <div className={className}>
      <Reveal>
        <p className="eyebrow">{index} — {eyebrow}</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-tight mt-6">{title}</h2>
      </Reveal>
    </div>
  );
}
